import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog,
  MatSelect
} from "@angular/material";

import { IBranch } from "src/app/interfaces/branch";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import * as moment from "jalali-moment";
import { RegistrationService } from "src/app/services/http/business/registration/registration.service";
import { CompanyRegistrationSearchComponent } from "../company-registration-search/company-registration-search.component";
import { ErrorsService } from "src/app/services/common/errors.service";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";
import { HttpHeaders } from "@angular/common/http";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";

@Component({
  selector: 'app-company-registration-list',
  templateUrl: './company-registration-list.component.html',
  styleUrls: ['./company-registration-list.component.css']
})
export class CompanyRegistrationListComponent implements OnInit {
UrlReport:string;
  param: any;
  errObject: any;
  errors = new Array();
  CompanyEncryptId: string;
  branchList: IBranch[];
  companyList: ICompany[];
  hideTable: boolean = true;
  nationalCode: string;
  filter: any;
  quaryParams: { RegisterStartDate: string; RegisterEndDate: string; };

  displayedColumns: string[] = [
    this.translate.get("label.branch"),
    this.translate.get("label.fullname"),
    this.translate.get("label.educationPackage"),
    this.translate.get("label.coursePatternName"),
    this.translate.get("label.termInfoName"),
    "teacherName",
    "score",
    "courseTime",
    this.translate.get("label.registrationStatusName"),
    "function"

  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private branchService: BranchService,
    private snackBar: SnackBarService,
    private route: ActivatedRoute,
    private errorService: ErrorsService,
    private companyService: CompanyService,
    private registrationService: RegistrationService
  ) { }

  ngOnInit() {
    this.getCompanyList();
    this.dataSource.paginator = this.paginator;
    this.route.params.subscribe(params => {
      this.nationalCode = params['nationalCode'];
      if (this.nationalCode) {
        this.filter = { NationalCode: this.nationalCode }
        this.refresh();
      }
    });
    this.UrlReport= environment.ReportBaseUrl;
  
    
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
      if (this.companyList.length >= 0) {
        this.defultSetCompanty(this.companyList[0].CompanyEncryptId);
      }
    });
  }

  defultSetCompanty(companyEncryptId: any) {

    this.quaryParams = {
      RegisterStartDate: this.getDateOfThePreviousYear(new Date()),
      RegisterEndDate: this.changDateFormat(new Date())
    };
    this.dataSource = null;
    this.cidService.setCID(companyEncryptId);
    this.loadRegistration(companyEncryptId);
  }

  getDateOfThePreviousMonth(dateTime: Date): string {
    const date = moment(dateTime.setMonth(dateTime.getMonth() - 1));
    return this.changDateFormat(date);
  }

  getDateOfThePreviousYear(dateTime: Date): string {
    const date = moment(dateTime.setMonth(dateTime.getMonth() - 240));
    return this.changDateFormat(date);
  }

  changDateFormat(dateTime: any): string {
    return moment(dateTime).format('YYYY/MM/DD h:mm');
  }

  getColor(statusId) {
    switch (statusId) {
      case 121:
        return "custom-chips success";
      case 120:
        return "custom-chips accent";
      case 122:
        return "custom-chips accent";
      case 123:
        return "custom-chips success";
      case 124:
        return "custom-chips accent";
      case 125:
        return "custom-chips warn";
      case 127:
        return "custom-chips primary";
      case 129:
        return "custom-chips accent";
      case 130:
        return "custom-chips primary";
      default:
        return "custom-chips default";
    }
  }

  search() {
    this.dialog
      .open(CompanyRegistrationSearchComponent, {
        width: '650px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {
        console.log(res);
        this.filter = res
        this.refresh();

      });
  }

  getBranchList() {
    this.branchService.listByLogin(0, 0).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  setCid(companyEncryptId: MatSelect) {
    this.dataSource = null;
    this.cidService.setCID(companyEncryptId.value);
    this.loadRegistration(companyEncryptId.value);
  }

  loadRegistration(companyEncryptId: string) {
    this.dataSource = null;
    this.CompanyEncryptId = companyEncryptId;
    this.filter = null;
    if (!this.nationalCode)
      this.refresh();
  }

  cancelRegistration(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: 'آیا از لغو ثبت نام اطمینان دارید؟',
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "300px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          var command = {
            id: data.Id
          }
          this.registrationService.cancelRegistration(command).subscribe(() => {
            this.refresh();
            this.snackBar.OpenSnackBar(
              'ثبت نام لغو شد.',
              "ok",
              3000,
              SoundEnum.beep
            );

          },
            () => {
              this.snackBar.OpenSnackBar(
                'خطا در لغو.',
                "ok",
                3000,
                SoundEnum.beep
              );
            }
          );
        }
      });
  }

  refresh() {
    if (this.filter) {
      //for moment RegisterStartDate change format
      if (this.filter.RegisterStartDate)
        this.filter.RegisterStartDate = moment
          .from(this.filter.RegisterStartDate, "en")
          .utc(true)
          .format(environment.dateFormat);
      else
        this.filter.RegisterStartDate = this.getDateOfThePreviousYear(new Date());

      if (this.filter.RegisterEndDate)
        this.filter.RegisterEndDate = moment
          .from(this.filter.RegisterEndDate, "en")
          .utc(true)
          .format(environment.dateFormat);
      else
        this.filter.RegisterEndDate = this.changDateFormat(new Date());
    }
    else
      this.filter = this.quaryParams;

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.filter && this.filter.CompanyEncryptId ? this.filter.CompanyEncryptId : this.CompanyEncryptId
      );

    // if (this.filter && this.filter.RegisterStartDate)
    this.registrationService.registerFullList(this.filter, 1, 10, headers).subscribe(res => {

      console.log(res.DataList);

      this.hideTable = false;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    }, err => {
      this.errObject = this.errorService.getError(err);
      this.param = this.errorService.objectError(this.errObject);
      this.errors = this.errorService.returnError(err);
    }
    );
  }
  paginatorEvent(event) {

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.filter && this.filter.CompanyEncryptId ? this.filter.CompanyEncryptId : localStorage.getItem("companyCode")
      );

    this.registrationService.registerFullList(this.filter, event.pageIndex + 1, event.pageSize, headers)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

}
